var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14.5V15.625C12.25 16.5201 11.8944 17.3786 11.2615 18.0115C10.6286 18.6444 9.77011 19 8.875 19H4.375C3.47989 19 2.62145 18.6444 1.98851 18.0115C1.35558 17.3786 1 16.5201 1 15.625V4.375C1 3.47989 1.35558 2.62145 1.98851 1.98851C2.62145 1.35558 3.47989 1 4.375 1H8.875C9.77011 1 10.6286 1.35558 11.2615 1.98851C11.8944 2.62145 12.25 3.47989 12.25 4.375V5.5M16.75 14.5L21.25 10L16.75 14.5ZM21.25 10L16.75 5.5L21.25 10ZM21.25 10H5.5H21.25Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout-white.246330f3d607d20875f1cffa3d3b3988.svg";
export { ForwardRef as ReactComponent };